<app-login-page>
  <div class="sign-in-container">
    <div class="message-container">
      <p-messages key="signInMessages" [closable]="false" data-cy="signin-messages-container"></p-messages>
    </div>
    <div class="message-container" *ngIf="isSessionExpired$ | async">
      <app-message severity="warn" [noMargin]="false" data-cy="session-expired-message">
        Your session has expired. Please sign in again.
      </app-message>
    </div>
    <div *ngIf="signInState === 'LOGIN'">
      <div class="email-form-container">
        <app-login-form
          [username]="username || ''"
          [updateUsername]="setUsername.bind(this)"
          [forgotPassword]="onForgotPassword.bind(this)"
          [signInWithCode]="onSignInWithCode.bind(this)"
        >
        </app-login-form>
      </div>
    </div>
    <div *ngIf="signInState === 'SEND_CODE'">
      <div class="email-form-container">
        <app-send-code-form
          [username]="username || ''"
          [factor]="factor || ''"
          [updateUsername]="setUsername.bind(this)"
          [setPhoneNumber]="setPhoneNumber.bind(this)"
          [onOtpSent]="onOtpSent.bind(this)"
          [onUsePassword]="onSignIn.bind(this)"
          [forgotPassword]="onForgotPassword.bind(this)"
        >
        </app-send-code-form>
      </div>
    </div>
    <div *ngIf="signInState === 'VERIFY_CODE'">
      <div class="email-form-container">
        <app-verify-code-form
          [onUsePassword]="onSignIn.bind(this)"
          [email]="username || ''"
          [phone]="phoneNumber || ''"
          [factor]="factor || ''"
        >
        </app-verify-code-form>
      </div>
    </div>
    <div *ngIf="signInState === 'RESET_PASSWORD'">
      <div class="email-form-container">
        <app-forgot-form
          [username]="username || ''"
          [onSignIn]="onSignIn.bind(this)"
          [onSuccessfulReset]="onGoToSent.bind(this)"
          [updateUsername]="setUsername.bind(this)"
        ></app-forgot-form>
      </div>
    </div>
    <div *ngIf="signInState === 'RESET_SUCCESS'">
      <div class="email-form-container">
        <app-forgot-success [username]="username || ''" [onBackToSignIn]="onSignIn.bind(this)"></app-forgot-success>
      </div>
    </div>
    <div *ngIf="signInState === 'UPDATE_PASSWORD'">
      <div class="email-form-container">
        <app-update-form [recoveryToken]="resetPasswordToken || ''" [onSignIn]="onSignIn.bind(this)"></app-update-form>
      </div>
    </div>
    <div *ngIf="signInState === 'ACTIVATE'">
      <div class="email-form-container">
        <app-activate-form
          [onBackToSignIn]="onSignIn.bind(this)"
          [activateToken]="welcomeToken || ''"
          [userToken]="userToken || ''"
          [directOnError]="directOnError.bind(this)"
          [onSignIn]="onSignIn.bind(this)"
        ></app-activate-form>
      </div>
    </div>
    <div *ngIf="signInState === 'ERROR_ACCOUNT_ACTIVATED'">
      <div class="email-form-container">
        <app-link-used-error [onBackToSignIn]="onSignIn.bind(this)"></app-link-used-error>
      </div>
    </div>
    <div *ngIf="signInState === 'ERROR_TOKEN_EXPIRED'">
      <div class="email-form-container">
        <app-link-expired-error
          [onBackToSignIn]="onSignIn.bind(this)"
          [userToken]="userToken || ''"
        ></app-link-expired-error>
      </div>
    </div>
  </div>
</app-login-page>
